module.exports = __webpack_public_path__ + "static/media/logos_squares_Platinum_REC.b77a6cbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Platinum_REC.png
// module id = 92
// module chunks = 0